import { ConfigFn } from '@config/types'

const config = (({ recommendationsUrl }) =>
  ({
    apiUrl: recommendationsUrl,
  }) as const) satisfies ConfigFn

export default config
